var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 -4 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 0.666016H2.66665C1.64915 0.666016 0.84248 1.48185 0.84248 2.49935L0.833313 13.4993C0.833313 14.5168 1.64915 15.3327 2.66665 15.3327H17.3333C18.3508 15.3327 19.1666 14.5168 19.1666 13.4993V2.49935C19.1666 1.48185 18.3508 0.666016 17.3333 0.666016ZM16.4166 13.4993H3.58331C3.07915 13.4993 2.66665 13.0868 2.66665 12.5827V7.99935H17.3333V12.5827C17.3333 13.0868 16.9208 13.4993 16.4166 13.4993ZM17.3333 4.33268H2.66665V3.41602C2.66665 2.91185 3.07915 2.49935 3.58331 2.49935H16.4166C16.9208 2.49935 17.3333 2.91185 17.3333 3.41602V4.33268Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment-icon.750c95998342224480854969324fd4f3.svg";
export { ForwardRef as ReactComponent };